"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _activePortal = require("../activePortal");

var _assignableUsergroups = require("./assignableUsergroups.actions");

/**
 * Created by EHelbing on 06.11.2017.
 */
var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _assignableUsergroups.FIND_ASSIGNABLE_USERGROUPS_SUCCESS:
      return action.body.userGroups;

    case _activePortal.CHANGE_ACTIVE_PORTAL:
      return [];

    default:
      return state;
  }
};

exports["default"] = _default;